import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {TimeRange} from '../models';
import {formatTime} from '../utils';
import {AudioElementStore} from './AudioElementStore';
import {AudioProgressStore} from './AudioProgressStore';

interface Props {
  store: AudioProgressStore,
  updateAudio?: AudioElementStore,
  className?: string;
}


function percent(value: number) {
  return (100 * value).toFixed(2) + '%';
}

function currentTimeStyle(currentTime: number, duration: number, isStudent: boolean = false) {
  if (isStudent) {
    return {
      width: duration === 0 ? '0' : percent((currentTime - 0.8) / duration)
    };
  } else {
    return {
      width: duration === 0 ? '0' : percent(currentTime / duration)
    };
  }
}

function bufferedSegmentStyle(range: TimeRange, duration: number) {
  return {
    left: percent(range.start / duration),
    width: percent((range.end - range.start) / duration)
  };
}

function preventContextMenu(event: React.MouseEvent) {
  event.preventDefault();
}

@observer
export class AudioProgress extends React.Component<Props> {
  readonly progressElement = React.createRef<HTMLDivElement>();

  render() {
    const store = this.props.store;

    const classname = classNames('audio-progress-container', this.props.className);

    return (
      <>
        <div className="audio-time">
          <span>{formatTime(store.currentTime > 1 && this.props.className == 'student-progress' ? store.currentTime - 0.8 : store.currentTime)}</span><span>{formatTime(store.duration)}</span>
        </div>

        <div className={classname}
             ref={this.progressElement}
             onContextMenu={preventContextMenu}>
          {
            store.canShowProgress &&
            store.buffered.map(range =>
              <div key={range.start}
                   className="buffered-range"
                   style={bufferedSegmentStyle(range, store.duration)}/>
            )
          }

        {
          store.draggingTime === null &&
          <div className="current-time" style={currentTimeStyle(store.currentTime, store.duration, this.props.className == 'student-progress')}><span className="playerHolder"></span></div>
        }

        {
          store.draggingTime !== null &&
          <div className="current-time"
               style={currentTimeStyle(store.draggingTime, store.duration)}><span className="playerHolder"></span></div>
        }
        </div>
      </>
    );
  }

  componentDidMount() {
    const audioStore = this.props.updateAudio;
    if (audioStore === null || audioStore === undefined)
      return;
    this.props.store.updateCurrentTimeOnDrag(audioStore, this.progressElement.current!);
  }
}
